import useConversations from "../../common/hooks/use-conversations"
import { ConversationsList, If } from "../../common/ui"

const ConversationsWithList: React.FC = () => {
  const { error, isLoading } = useConversations()

  return (
    <div className="flex flex-1 overflow-hidden h-full">
      <ConversationsList />

      <If
        condition={!isLoading && !error}
        then={
          <div className="bg-neutral-50 flex-col items-center justify-center w-full hidden md:flex">
            <p>Select a thread to view messages.</p>
          </div>
        }
      />
    </div>
  )
}

export default ConversationsWithList
